// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner-module--loader--3Jvmx","load6":"Spinner-module--load6--12mkE","round":"Spinner-module--round--32iCU","centered":"Spinner-module--centered--30r10"};